import React from "react";

// Sparkles icon
export const SparklesIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" {...props} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M12 8l2 4 4 2-4 2-2 4-2-4-4-2 4-2 2-4zM19 3v4m-2-2h4" />
  </svg>
);

export const PathIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" {...props} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

export const LibraryIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" {...props} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 19h16M4 4h16v15H4z" />
  </svg>
);

export const UsersIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" {...props} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20v-2a4 4 0 00-8 0v2M5 8a4 4 0 118 0 4 4 0 01-8 0zM12 8a4 4 0 118 0 4 4 0 01-8 0z" />
  </svg>
);

export const FileTextIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" {...props} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 2h8l5 5v15H7V2z" />
  </svg>
);

export const MegaphoneIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" {...props} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 11v2a4 4 0 004 4h1l3 4V7L8 11H7a4 4 0 00-4 4zM16 3v18" />
  </svg>
);

export const BarChartIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" {...props} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3v18h18M9 17V9m4 8v-5m4 5V5" />
  </svg>
);

export const SearchIcon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
);
